import { shape } from './SchedulingMap/mapIcons';

export const createCustomMarkerElement = (icon) => {
    const img = document.createElement("img");
    img.src = icon.url;
    
    // Handle Google Maps Size object or plain object
    const width = icon.size?.width || 40;
    const height = icon.size?.height || 40;
    
    img.style.width = `${width}px`;
    img.style.height = `${height}px`;
    img.style.objectFit = "contain";
    
    // CRITICAL for functionality:
    // This ensures the image doesn't look like text to the browser (preventing drag selection)
    img.style.userSelect = 'none'; 
    
    // This ensures the image acts as a solid object for clicking
    img.style.pointerEvents = 'auto'; 
    
    // Handle Anchor (Center the pin tip)
    const anchorX = icon.anchor?.x || 0;
    const anchorY = icon.anchor?.y || 0;
    
    // We use margin or translate to offset. Translate is smoother for rendering.
    // Note: AdvancedMarkerElement usually centers content. 
    // If your anchor is (0, 20) [bottom-center], and the image is 20x20, 
    // you likely want to shift it up by half height?
    // Actually, trust your mapIcons config. If it says anchor (0, 20), rely on that.
    img.style.transform = `translate(${-anchorX}px, ${-anchorY}px)`;
    
    return img;
};